export default __webpack_public_path__ + "3931ef9ee9c2a202849e195637dfbcb2.wasm";